import React, { Component, Fragment } from 'react';
import { Helmet } from 'react-helmet';
import { connect } from 'react-redux';
import {withRouter} from 'react-router';
import { pageViewEvent } from '../../../SHARED/helpers/general.helper';
import colorLine from '../../resources/img/color-line.jpg';
import logos from '../../resources/img/fonduri.jpg';

class AboutProject extends Component {

    componentWillMount(){
        window.scrollTo(0, 0);
    }

    componentDidMount() {
        pageViewEvent('Despre proiect',window.location.href);
     }

    render() {
        return (
                <div className="wrapper">
                    <Helmet>
                        <title>Despre proiect</title>
                        <meta name="description" content='Despre proiectul "CINEMAP - PLATFORMA DE FILM"'/>
                        <link rel='canonical' href={window.location.href}/>
                    </Helmet>
                    <div className="about-project-page">
                        {/*<img src={AboutProjectImg} />*/}
                        <div className="container">
                            <img src={logos} />
                            <p className="text-center title">Despre proiect</p>

                            <p>Proiectul "CINEMAP - PLATFORMA DE FILM", cod SMIS 108515, finanțat prin Programul Operațional Regional 2014-2020, a fost implementat în perioada 01.09.2016 - 28.02.2019 (30 de luni) de către societatea CITY GUIDE MEDIA SRL. Valoarea totală a proiectului a fost egală cu 839.142,66 lei, din care 563.497,27 lei reprezintă finanțare nerambursabilă.</p>
                            <br/>
                            <p>Programul Operațional Regional 2014-2020 este implementat la nivel național de către Ministerul Dezvoltării Regionale și Administrației Publice, în calitate de Autoritate de Management, iar la nivel regional de către ADR Centru, Organism Intermediar al programului ce monitorizează implementarea acestui proiect în Regiunea Centru. </p>
                            <br/>
                            <p>Obiectivul general al proiectului l-a reprezentat consolidarea poziției față de piața a SC CITY GUIDE MEDIA SRL prin diversificarea activității acesteia și creșterea inovativă a calității produselor sale și a fost atins prin conceperea și dezvoltarea platformei on-line CINEMAP (site și aplicație).<br/>Ca urmare a implementării proiectului, au fost obținute următorele rezultate, cu impact la nivel local:</p>
                            <br/>
                            <p>- S-a realizat o platformă web (site web responsive și aplicație pentru telefoanele mobile)</p>
                            <p>- Au fost create cinci locuri noi de muncă (dintre care două au fost ocupate de persoane care fac parte din grupuri defavorizate).</p>
                            <br/><br/><br/>
                            <hr className="blue-hr"/>
                            <br/>
                            <p className="text-center">Pentru informații detaliate despre celelalte programe cofinanțate de Uniunea Europeană, <br/>vă invităm să vizitați <a href="http://www.fonduri-ue.ro" target="_blank">www.fonduri-ue.ro</a></p>
                            <br/>
                            <hr className="blue-hr"/>
                            <p className="text-center">Investim în viitorul tău!</p>
                            <p className="text-center">Proiect cofinanțat din Fondul European de Dezvoltare Regională <br/> prin Programul Operațional Regional 2014-2020</p>
                            <p className="text-footer">Conținutul acestui material nu reprezintă în mod obligatoriu poziția oficială a Uniunii Europene sau a Guvernului României.</p>
                        </div>
                        <div className="color-line-wrp">
                            <img src={colorLine} className="color-line"/>
                        </div>
                        <div className="footer-links text-center">
                            <p><a href="http://www.inforegio.ro" target="_blank" onClick={()=>{window.gtag('event','Visited another Website',{'event_category':'info_visit','event_label':'Inforegio website'})}}>www.inforegio.ro</a> | <a href="http://www.facebook.com/inforegio.ro" target="_blank" onClick={()=>{window.window.gtag('event','Visited another Website',{'event_category':'info_visit','event_label':'Inforegio Facebook Page'})}}>facebook.com/inforegio.ro</a></p>
                        </div>
                    </div>
                </div>
        );
    }
}

const mapStateToProps = state => ({
});

export default withRouter(connect(mapStateToProps,{})(AboutProject));



// WEBPACK FOOTER //
// ./src/FO/components/aboutproject/aboutproject.component.js